module.exports = __webpack_public_path__ + "img/weixin.4d713ab7.png";